export default function WalletStatus(value: string) {
  const name = () => {
    if (value.toLowerCase() === "deduct") return "Deduct";
    return "Pop up";
  };

  if (name() === "Deduct")
    return (
      <p className="capitalize w-24 text-white text-center rounded-xl bg-red-500">
        {name()}
      </p>
    );
  return (
    <p className="capitalize w-24 text-white text-center rounded-xl bg-green-400">
      {name()}
    </p>
  );
}
